module.exports = __webpack_public_path__ + "static/media/Drift-preview.961745ae.jpg";